import type {
  ComponentProps,
  CSSProperties,
} from "react"
import { useMemo } from "react"
import type { VariableSizeList } from "react-window"
import { useGraphContext } from "./GraphContext"
import { GraphItem } from "./GraphItem"
import styles from "./VirtualListItem.module.scss"

interface Props {
  index: number;
  style: CSSProperties;
  // TODO aria attributes
}

export const VirtualListItem: ComponentProps<typeof VariableSizeList>["children"] = (props: Props) => {
  const {
    index,
    style,
  } = props

  const { numberOfItems } = useGraphContext()

  const children = useMemo(
    () => index === numberOfItems - 1 ? null : (
      <GraphItem
        index={index}
      />
    ),
    [
      index,
      numberOfItems,
    ],
  )

  return (
    <div
      className={styles.item}
      style={style}
    >
      {children}
    </div>
  )
}
